import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function AddIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path stroke={color || defaultColor} fill="none" strokeLinecap="round" d="M7 1V13" />
    <path stroke={color || defaultColor} fill="none" strokeLinecap="round" d="M13 7L1 7" />
  </SvgIcon>
}
